import { api } from "../client";

export const getMonthlyUtilization = (params) => {
  const { monthStart, floorName, excludeDepartments, filterZones } = params;

  // Parse year and month from monthStart date
  const date = new Date(monthStart);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // JavaScript months are 0-indexed

  const queryParams = new URLSearchParams();
  queryParams.append("year", year.toString());
  queryParams.append("month", month.toString());

  if (floorName && floorName !== "all") {
    queryParams.append("floorName", floorName);
  }

  if (excludeDepartments && excludeDepartments.length > 0) {
    queryParams.append("excludeDepartments", excludeDepartments.join(","));
  }

  if (filterZones && filterZones.length === 1) {
    queryParams.append("filterZones", filterZones.join(","));
  }

  return api.get(`/api/utilization/monthly?${queryParams}`);
};
